export function checkUrl(possibleUrl: string): URL | undefined {
  try {
    // eslint-disable-next-line no-new
    const result = new URL(possibleUrl);
    return result;
  } catch {
    return undefined;
  }
}
